var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3957_5168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.5C20.5 8.08176 16.9182 4.5 12.5 4.5C8.08176 4.5 4.5 8.08176 4.5 12.5C4.5 16.2517 7.08304 19.3998 10.5675 20.2645V14.9448H8.91792V12.5H10.5675V11.4466C10.5675 8.72368 11.7998 7.4616 14.4731 7.4616C14.98 7.4616 15.8546 7.56112 16.2123 7.66032V9.87632C16.0235 9.85648 15.6955 9.84656 15.2882 9.84656C13.9765 9.84656 13.4696 10.3435 13.4696 11.6354V12.5H16.0827L15.6338 14.9448H13.4696V20.4414C17.4309 19.963 20.5003 16.5902 20.5003 12.5H20.5Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6338 14.9447L16.0828 12.4999H13.4696V11.6353C13.4696 10.3435 13.9765 9.84651 15.2882 9.84651C15.6956 9.84651 16.0236 9.85643 16.2124 9.87627V7.66027C15.8546 7.56075 14.98 7.46155 14.4732 7.46155C11.7999 7.46155 10.5676 8.72363 10.5676 11.4465V12.4999H8.91797V14.9447H10.5676V20.2644C11.1864 20.418 11.8338 20.4999 12.5 20.4999C12.828 20.4999 13.1516 20.4798 13.4693 20.4414V14.9447H15.6335H15.6338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3957_5168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.eed8abd122ca57ed564ff725acdbbde2.svg";
export { ForwardRef as ReactComponent };